import React from 'react';
import {
	BarChart,
	Bar,
	Rectangle,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from 'recharts';

const data = [
	{ name: 'Page A', uv: 4000, pv: 2400, amt: 2400 },
	{ name: 'Page B', uv: 3000, pv: 1398, amt: 2210 },
	{ name: 'Page C', uv: 2000, pv: 9800, amt: 2290 },
	{ name: 'Page D', uv: 2780, pv: 3908, amt: 2000 },
	{ name: 'Page E', uv: 1890, pv: 4800, amt: 2181 },
	{ name: 'Page F', uv: 2390, pv: 3800, amt: 2500 },
	{ name: 'Page G', uv: 3490, pv: 4300, amt: 2100 },
];

const BarChartComponents = () => {
	return (
		<div className='w-full md:w-1/2 h-[450px] shadow-md rounded-lg p-4  mt-6 bg-[#F3FDE8]'>
			<ResponsiveContainer width='100%' height='90%'>
				<BarChart data={data} margin={{ top: 10, right: 30, left: 10, bottom: 10 }}>
					<CartesianGrid strokeDasharray='3 3' />
					<XAxis dataKey='name' />
					<YAxis />
					<Tooltip />
					<Legend />
					<Bar
						dataKey='pv'
						fill='#A9C46C'
						activeBar={<Rectangle fill='#DDEFB5' stroke='#DDEFB5' />}
					/>
					<Bar
						dataKey='uv'
						fill='#213555'
						activeBar={<Rectangle fill='#60728F' stroke='#60728F' />}
					/>
				</BarChart>
			</ResponsiveContainer>
		</div>
	);
};

export default BarChartComponents;
